import { render, staticRenderFns } from "./MenuProduct.vue?vue&type=template&id=9b796d8e&scoped=true&"
import script from "./MenuProduct.vue?vue&type=script&lang=js&"
export * from "./MenuProduct.vue?vue&type=script&lang=js&"
import style0 from "./MenuProduct.vue?vue&type=style&index=0&id=9b796d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b796d8e",
  null
  
)

export default component.exports